var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4426 6.74013L18.0876 4.38505C15.3104 1.60789 11.4348 0.605421 7.86145 1.38245L9.24764 2.76864C9.55941 2.69189 9.89037 2.64873 10.2261 2.64873C12.4901 2.64873 14.3223 4.48098 14.3223 6.74493C14.3223 7.08068 14.2792 7.41164 14.2024 7.72341L16.735 10.256C17.2098 9.91541 17.6607 9.52689 18.0876 9.1L20.4426 6.74493V6.74013Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7441 4.26367L12.7011 6.22064C12.4949 5.24216 11.7226 4.46992 10.7441 4.26367Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3584 11.0991L13.4781 9.21885L12.3558 8.09647L8.86391 4.60463L7.74154 3.48225L6.1539 1.89461L4.25928 0L3.1465 1.11279L4.6526 2.61888C3.8324 3.09374 3.05536 3.6837 2.35508 4.38399L0 6.73907L2.35508 9.09415C5.44881 12.1879 9.91914 13.08 13.7995 11.761L15.8476 13.8091L16.9604 12.6963L15.3584 11.0943V11.0991ZM10.2213 10.8353C7.95738 10.8353 6.12512 9.00301 6.12512 6.73907C6.12512 5.97643 6.33137 5.26655 6.6959 4.65739L7.86145 5.82294C7.75113 6.10593 7.68877 6.4177 7.68877 6.73907C7.68877 8.13964 8.82075 9.27162 10.2213 9.27162C10.5427 9.27162 10.8545 9.20926 11.1375 9.09894L12.303 10.2645C11.6938 10.6242 10.9792 10.8353 10.2213 10.8353Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/CloseEye.2c78188f8bdfe2a4259adefbbf4690c0.svg";
export { ForwardRef as ReactComponent };